import { render, staticRenderFns } from "./order-goods-list.vue?vue&type=template&id=4746a43b"
import script from "./order-goods-list.vue?vue&type=script&lang=js"
export * from "./order-goods-list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports